interface LoadingSkeletonProps {
  /** Number of skeleton cards to render */
  cards?: number;
  /** Number of skeleton rows for table-like areas */
  rows?: number;
}

function SkeletonCard() {
  return (
    <div className="animate-pulse rounded-lg border border-line-subtle bg-surface px-4 py-3">
      <div className="h-3 w-20 rounded bg-surface-3" />
      <div className="mt-2 h-6 w-16 rounded bg-surface-3" />
    </div>
  );
}

function SkeletonRow() {
  return (
    <div className="animate-pulse flex gap-4 py-2">
      <div className="h-4 w-1/4 rounded bg-surface-3" />
      <div className="h-4 w-1/6 rounded bg-surface-3" />
      <div className="h-4 w-1/6 rounded bg-surface-3" />
      <div className="h-4 w-1/6 rounded bg-surface-3" />
    </div>
  );
}

export function LoadingSkeleton({ cards = 0, rows = 0 }: LoadingSkeletonProps) {
  return (
    <div className="space-y-4" aria-busy="true" aria-label="Loading">
      <span className="sr-only">Loading...</span>
      {cards > 0 && (
        <div className="grid grid-cols-3 gap-3 lg:grid-cols-5">
          {Array.from({ length: cards }, (_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      )}
      {rows > 0 && (
        <div className="rounded-lg border border-line-subtle bg-surface p-4">
          {Array.from({ length: rows }, (_, i) => (
            <SkeletonRow key={i} />
          ))}
        </div>
      )}
    </div>
  );
}
